import type { OrganizationPointDto } from "common/models/api/models/OrganizationPointDto";
import type { PointsFindByRequest } from "common/models/point/PointsFindByRequest";
import { UseQueryResult } from "react-query";
import { UseCustomQueryOptions } from "ui/query/react-query-overrides";
import usePointFindBy from "features/points/hooks/usePointFindBy";

export default function usePointConversionRate(
    { organizationAddress }: Partial<PointsFindByRequest> = {},
    options: Omit<
        UseCustomQueryOptions<OrganizationPointDto, unknown, OrganizationPointDto["conversionRate"], (string | undefined)[]>,
        "select"
    > = {},
): UseQueryResult<OrganizationPointDto["conversionRate"]> {
    return usePointFindBy({ organizationAddress }, { select: (data) => data?.conversionRate, ...options });
}
